import {lazy, StrictMode, Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const isAdminRoute = window.location.pathname.startsWith('/admin');
const AdminDashboard = lazy(() => import('./AdminDashboard.tsx').then(({ AdminDashboard }) => ({ default: AdminDashboard })));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAdminRoute ? (
      <Suspense fallback={null}>
        <AdminDashboard />
      </Suspense>
    ) : <App />}
  </StrictMode>,
);
